<script lang="ts">
  import DepositContent from "$lib/components/ModalContents/DepositWithdraw/Deposit/DepositContent.svelte";
  import WithdrawContent from "$lib/components/ModalContents/DepositWithdraw/Withdraw/WithdrawContent.svelte";
  import type {IUser} from "$lib/interfaces/IUserMe";

  interface Props {
    isDeposit?: boolean;
    data: IUser;
  }

  let { isDeposit = $bindable(true), data }: Props = $props();
</script>

<div class="text-white">
  <!-- Tab navigation -->
  <div class="flex justify-center items-center mb-6 bg-primary-dark/30 rounded-full p-1.5">
    <button
            class={`flex-1 py-2.5 px-6 rounded-full font-medium transition-all duration-200 ${isDeposit ? 'bg-primary-fire text-white shadow-lg' : 'text-white/70 hover:text-white'}`}
            onclick={() => isDeposit = true}
    >
      <div class="flex items-center justify-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
        </svg>
        <span>Deposit</span>
      </div>
    </button>
    <button
            class={`flex-1 py-2.5 px-6 rounded-full font-medium transition-all duration-200 ${!isDeposit ? 'bg-primary-fire text-white shadow-lg' : 'text-white/70 hover:text-white'}`}
            onclick={() => isDeposit = false}
    >
      <div class="flex items-center justify-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
        </svg>
        <span>Withdraw</span>
      </div>
    </button>
  </div>

  <!-- Content area with animation -->
  <div class="animate-fadeIn">
    {#if isDeposit}
      <DepositContent localUser={data} />
    {:else}
      <WithdrawContent />
    {/if}
  </div>
</div>

<style>
  .animate-fadeIn {
    animation: fadeIn 0.3s ease-in-out;
  }

  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
  }
</style>